import {ReviewDataType} from '../../../service/reviews/reviews-type';
import {getDateInCurrentTimezone} from '../../../util/date';
import {ProvidersIdsEnum} from '../../../util/type';

export function isReviewReplyAvailableWhenVisible(review: ReviewDataType): boolean {
    const {brand, deletedAt, ableToReply} = review;

    return (ableToReply || brand.isTest) && !deletedAt;
}

export function isReviewAbuseAvailableWhenVisible(review: ReviewDataType): boolean {
    const {ableToAbuse, abuseLastDate, catalogId, deletedAt} = review;

    if (!ableToAbuse || deletedAt) {
        return false;
    }

    if (!abuseLastDate) {
        return true;
    }

    return catalogId !== ProvidersIdsEnum.yandex;
}

export function isReviewReplyAllowed(review: ReviewDataType): boolean {
    const {isHidden} = review;

    return isReviewReplyAvailableWhenVisible(review) && !isHidden;
}

export function isReviewAbuseAllowed(review: ReviewDataType): boolean {
    const {isHidden} = review;

    return isReviewAbuseAvailableWhenVisible(review) && !isHidden;
}

export function getReviewCreationDate(review: {
    createdInCatalog: ReviewDataType['createdInCatalog'];
    createdInRd: ReviewDataType['createdInRd'];
}): string {
    const {createdInCatalog, createdInRd} = review;

    return getDateInCurrentTimezone(new Date(createdInCatalog || createdInRd))
        .toISOString()
        .replace('Z', '');
}
